export const language: any = {
    OkLogout: "Ya",
    CloseLogout: "Tidak",
    OkLeave: "Keluar",
    CloseLeave: "Batal",
    LabelPolicy: "Kebijakan Privasi",
    AppName: "Hey! Cooker",
    OnOffNotification: "Notifikasi Hidup/Mati",
    LabelReceiveNotificationSuggestion: "Terima notifikasi saran resep",
    LabelReceiveNotifyBreakfast: "Terima rekomendasi sarapan harian",
    LabelReceiveNotifyLunch: "Terima rekomendasi makan siang harian",
    LabelReceiveNotifyDinner: "Terima rekomendasi makan malam harian",
    notification_history: "Riwayat Notifikasi",
    readAll: "Baca semua",
    no_notification: "Tidak ada riwayat notifikasi",
    labelDisplayName: "Masukkan nama tampilan",
    placeholderDisplayName: "Masukkan minimal 4 karakter, maksimal 20 karakter",
    changeDisplayName: "Ubah nama tampilan",
};
